// extracted by mini-css-extract-plugin
module.exports = {"NavLogo":"NavLogo_NavLogo__3XgDl"};